import {useEffect, useState} from "react";
import useSWR from "swr";
import { Period} from "../../../../api/types";
import urls from "../../../../api/urls";
import {api} from "../../../../api/apiProvider";

export default function usePeriods(engineId: number) {
  const [periods, setPeriods] = useState<Period[]>([]);

  const {
    data: periodsData,
    mutate: mutatePeriods,
  } = useSWR<{
    data: Period[],
  }>(`${urls.periods}?engine.id=${engineId}&t[]=period&order[dateStart]=asc`, api.get, {
    revalidateOnFocus: false
  });

  useEffect(() => {
    if (periodsData && periodsData.data) {
      setPeriods(periodsData.data);
    }
  }, [periodsData]);

  return {
    periods,
    mutatePeriods,
  };
}
